import { type FC, useEffect, useState } from "react";
import { RolePermissions, UsersGroupsContext } from "../../../../enums";
import { type IWizardStep } from "../../../../interfaces/IWizardStepsManager";
import PeopleWrapper from "features/Library/PeopleAssignments/Overview/PeopleWrapper/PeopleWrapper";
import GroupsOverview from "./GroupsOverview";
import UsersOverview from "./UsersOverview";

interface EditExternalLinkPeopleProps extends IWizardStep {
  linkId: number;
}

export const EditExternalLinkPeople: FC<EditExternalLinkPeopleProps> = ({ linkId, acceptHandlers }) => {
  const [usersGroupsContext, setUsersGroupsContext] = useState(UsersGroupsContext.Groups);
  useEffect(() => {
    acceptHandlers?.({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PeopleWrapper
        permission={RolePermissions.AssetsManage}
        usersGroupsContext={usersGroupsContext}
        onContextChanged={setUsersGroupsContext}
        renderGroupsOverview={(customHeaderContent: React.ReactElement) => (
          <GroupsOverview linkId={linkId} customHeaderContent={customHeaderContent} />
        )}
        renderUsersOverview={(customHeaderContent: React.ReactElement) => (
          <UsersOverview linkId={linkId} customHeaderContent={customHeaderContent} />
        )}
      />
    </>
  );
};

export default EditExternalLinkPeople;
